var _path, _mask, _path2, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499023 10C0.499023 4.75329 4.75232 0.5 9.99902 0.5H39.999C45.2457 0.5 49.499 4.7533 49.499 10V40C49.499 45.2467 45.2457 49.5 39.999 49.5H9.99902C4.75232 49.5 0.499023 45.2467 0.499023 40V10Z",
    stroke: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1_1757",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.999 32.098C31.6264 32.098 36.999 28.4943 36.999 24.049C36.999 19.6037 31.6264 16 24.999 16C18.3716 16 12.999 19.6037 12.999 24.049C12.999 27.2598 15.802 30.0316 19.8562 31.3234V34.7809L24.5789 32.0931C24.7184 32.0963 24.8584 32.098 24.999 32.098Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8562 31.3234H21.3562V30.227L20.3116 29.8942L19.8562 31.3234ZM19.8562 34.7809H18.3562V37.3605L20.5981 36.0846L19.8562 34.7809ZM24.5789 32.0931L24.6135 30.5935L24.1981 30.5839L23.837 30.7895L24.5789 32.0931ZM35.499 24.049C35.499 25.6184 34.5509 27.2189 32.6487 28.4947C30.7562 29.7642 28.0561 30.598 24.999 30.598V33.598C28.5694 33.598 31.8693 32.6299 34.3199 30.9862C36.7608 29.3489 38.499 26.9249 38.499 24.049H35.499ZM24.999 17.5C28.0561 17.5 30.7562 18.3338 32.6487 19.6032C34.5509 20.8791 35.499 22.4796 35.499 24.049H38.499C38.499 21.173 36.7608 18.749 34.3199 17.1118C31.8693 15.468 28.5694 14.5 24.999 14.5V17.5ZM14.499 24.049C14.499 22.4796 15.4471 20.8791 17.3493 19.6032C19.2418 18.3338 21.942 17.5 24.999 17.5V14.5C21.4286 14.5 18.1288 15.468 15.6782 17.1118C13.2372 18.749 11.499 21.173 11.499 24.049H14.499ZM20.3116 29.8942C16.5335 28.6903 14.499 26.305 14.499 24.049H11.499C11.499 28.2147 15.0705 31.3728 19.4008 32.7526L20.3116 29.8942ZM18.3562 31.3234V34.7809H21.3562V31.3234H18.3562ZM20.5981 36.0846L25.3208 33.3968L23.837 30.7895L19.1142 33.4773L20.5981 36.0846ZM24.999 30.598C24.8699 30.598 24.7414 30.5965 24.6135 30.5935L24.5443 33.5927C24.6953 33.5962 24.8469 33.598 24.999 33.598V30.598Z",
    fill: "white",
    mask: "url(#path-2-inside-1_1_1757)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.749,
    y1: 23.6499,
    x2: 21.249,
    y2: 23.6499,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24.749,
    y1: 23.6499,
    x2: 26.249,
    y2: 23.6499,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 29.749,
    y1: 23.6499,
    x2: 31.249,
    y2: 23.6499,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.e15b1f8d3b144387fcd3408d505593ec.svg";
export { ForwardRef as ReactComponent };